import {
  AfterContentInit,
  Component,
  ContentChildren,
  QueryList,
} from '@angular/core';
import { LayoutMainDirective } from '../layout-center.directive';
import { LayoutFooterDirective } from '../layout-footer.directive';
import { LayoutHeaderDirective } from '../layout-header.directive';

@Component({
  selector: 'am-layout-rows',
  templateUrl: './layout-rows.component.html',
  styleUrls: ['./layout-rows.component.scss'],
})
export class LayoutRowsComponent implements AfterContentInit {
  @ContentChildren(LayoutHeaderDirective, { descendants: false })
  headerEls: QueryList<LayoutHeaderDirective>;
  @ContentChildren(LayoutMainDirective, { descendants: false })
  mainEls: QueryList<LayoutMainDirective>;
  @ContentChildren(LayoutFooterDirective, { descendants: false })
  footerEls: QueryList<LayoutFooterDirective>;

  headerEl: LayoutHeaderDirective;
  mainEl: LayoutMainDirective;
  footerEl: LayoutFooterDirective;

  get gridTemplateRows(): string {
    const gtr = {
      header: this.headerEl ? this.headerEl.height : '0',
      center: '1fr',
      footer: this.footerEl ? this.footerEl.height : '0',
    };
    return Object.values(gtr).join(' ');
  }

  ngAfterContentInit() {
    this.headerEl = this.headerEls.toArray()[0];
    this.mainEl = this.mainEls.toArray()[0];
    this.footerEl = this.footerEls.toArray()[0];
  }
}
